import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "reading-streak-notification16464"
}
const _hoisted_2 = { class: "reading-streak-notification16464__text" }

import { onMounted, onUnmounted, ref } from 'vue'
import { App } from '@capacitor/app'

import { emitter } from '@/services/mitt'

import ReadingStreakIcon16464 from './ReadingStreakIcon16464.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ReadingStreakNotification16464',
  props: {
    streakLength: {}
  },
  setup(__props: any) {



const isVisible = ref(false)
const timeout = ref<number | null>(null)

onMounted(async () => {
  const appState = await App.getState()
  if (appState.isActive) {
    show()
  } else {
    emitter.on('appVisibilityChange', show)
  }
})

onUnmounted(() => {
  if (timeout.value) {
    clearTimeout(timeout.value)
  }
  emitter.off('appVisibilityChange', show)
})

function show(): void {
  isVisible.value = true
  timeout.value = setTimeout(hide, 5000)
}

function hide(): void {
  isVisible.value = false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "slide-down" }, {
    default: _withCtx(() => [
      (isVisible.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", {
              class: "reading-streak-notification16464__container",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (hide()))
            }, [
              _createElementVNode("p", _hoisted_2, " You have a " + _toDisplayString(__props.streakLength) + "-day streak. Keep it up! ", 1),
              _createVNode(ReadingStreakIcon16464, { class: "reading-streak-notification16464__icon" })
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})